// extracted by mini-css-extract-plugin
module.exports = {"comp":"WhatInBoxA_comp__CCtpg"};